export default function TopModuleNavComponent() {
	'ngInject';
	return {
		restrict: 'E',
		template: require('./top.nav.html'),
		scope: {
			module: '='
		}
	};
}
